import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/logo.png';
import './Footer.css';

const Footer = () => {
    const { t, i18n } = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    {/* About Section */}
                    <div className="footer-section">
                        <h3 className="footer-title">{t('footer.about')}</h3>
                        <div className="footer-logo">
                            <img src={logo} alt="SIGMA Elevators" className="logo-image" />
                        </div>
                        <p className="footer-description">
                            {t('hero.subtitle')}
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div className="footer-section">
                        <h3 className="footer-title">{t('footer.quickLinks')}</h3>
                        <ul className="footer-links">
                            <li><Link to="/">{t('nav.home')}</Link></li>
                            <li><Link to="/services">{t('nav.services')}</Link></li>
                            <li><Link to="/about">{t('nav.about')}</Link></li>
                            <li><Link to="/contact">{t('nav.contact')}</Link></li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div className="footer-section">
                        <h3 className="footer-title">{t('footer.contactInfo')}</h3>
                        <ul className="footer-contact">
                            <li>
                                <span className="contact-label">{t('contact.info.address')}:</span>
                                <span>{i18n.language === 'ar' ? '55 شارع محمد فريد - مصر الجديدة - القاهرة - مصر' : '55 Mohamed Farid St. Heliopolis - Cairo - Egypt'}</span>
                            </li>
                            <li>
                                <span className="contact-label">{t('contact.info.phone')}:</span>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                                    <a href="tel:+201020008449">+201020008449</a>
                                    <a href="tel:+20226438448">+20226438448</a>
                                    <a href="tel:+201007707607">+201007707607</a>
                                </div>
                            </li>
                            <li>
                                <span className="contact-label">{t('contact.info.email')}:</span>
                                <a href="mailto:info@sigmaelevator-eg.com">info@sigmaelevator-eg.com</a>
                            </li>
                        </ul>
                    </div>

                    {/* Social Media */}
                    <div className="footer-section">
                        <h3 className="footer-title">{t('footer.followUs')}</h3>
                        <div className="social-links">
                            <a
                                href="https://www.facebook.com/SIGMAELEVATORS"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-link"
                                aria-label="Facebook"
                            >
                                <svg className="social-icon" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                </svg>
                            </a>
                            <a
                                href="https://www.instagram.com/sigma_elevator_egypt"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-link"
                                aria-label="Instagram"
                            >
                                <svg className="social-icon" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                                </svg>
                            </a>
                            <a
                                href="https://www.tiktok.com/@sigma.elevator.eg"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-link"
                                aria-label="TikTok"
                            >
                                <svg className="social-icon" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <div className="footer-bottom">
                    <p className="copyright">
                        © {currentYear} {t('footer.copyright')}
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
